<app-primary-button
  class="center"
  [text]="'Update My Subscription'"
  (click)="onUpdateSubscriptionClick()"
></app-primary-button>
